import { render, staticRenderFns } from "./UserStatus.vue?vue&type=template&id=0010be9f&"
import script from "./UserStatus.vue?vue&type=script&lang=js&"
export * from "./UserStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports